import { useQuery } from '@tanstack/react-query';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { tagAutocompleteWithLimit } from 'services/search';

const getData = async ({ value, widgetType = SEARCH_WIDGET_TYPES.search, employeeIds = [], limit }) => {
  try {
    const res = await tagAutocompleteWithLimit({
      query: value,
      teamId: null,
      widgetType,
      employeeIds: employeeIds?.length ? employeeIds : null,
      limit,
    });
    return res;
  } catch (err) {
    console.error('Error in fetching competencies for employee list : ', err);
  }
};

export const useMentionCompetencyQuery = ({ value, widgetType, employeeIds = [], limit }) =>
  useQuery(
    [REACT_QUERY_KEYS.postField.competencyMention, value, widgetType, ...employeeIds, limit],
    () => getData({ value, widgetType, employeeIds, limit })
    // {
    //   enabled: Boolean(value)
    // }
  );
